import type { IAlertProps } from "@components/organisms/alert/types";

export const ALERT_DEFAULT_PROPS: IAlertProps = {
  open: false,
  title: "test.title",
  onClose: undefined,
  cancelButtonProps: undefined,
  submitButtonProps: undefined,
  linkButtonType: undefined,
  noIcon: false,
  children: undefined,
  description: undefined,
  variant: undefined,
  buttonsType: undefined,
  alignment: undefined,
  customIcon: undefined,
  backdrop: true,
};
